export const VERSION = '0.43';
